//@ts-nocheck
import Skeleton from '@mui/material/Skeleton';
import ShellLayout from '../../layouts/ShellLayout/ShellLayout';
import shellHeaderBuilder from '../../utils/shellHeaderBuilder';
import CreateTrip from '../../components/Trip/CreateTrip/CreateTrip';
import useFetchData from '../../hooks/useFetchData';
import TripsPanel from '../../components/Trips/TripsPanel/TripsPanel';
import { PlusCircle } from '@phosphor-icons/react';
import { XGButton } from 'xg-cl';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import * as PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { updateContentTypes } from '../../redux/slices/contenttypes/contenttypes';
import { statuses } from '../../utils/tripStatuses/tripStatuses';

/**
 * This is the trips page component.
 *
 * @namespace Pages
 */

const Trips = ({ id }) => {
  const { t } = useTranslation(['trips']);
  const { enableDisplayStatuses } = useFlags();
  const [openModal, setOpenModal] = useState(false);
  const [destinationOptions, setDestinationOptions] = useState([]);
  const [createdByOptions, setCreatedByOptions] = useState([]);
  const dispatch = useDispatch();
  const {
    data: destinationsData,
    isLoading: destinationsLoading,
    error: destinationsError
  } = useFetchData(`/destinations`);

  const { data: staffUsersData } = useFetchData(`/staffusers`);

  const {
    data: tripStatusesData,
    isLoading: tripStatusesLoading,
    error: tripStatusesError
  } = useFetchData(`/tripstatuses`);

  const {
    data: contentTypeData,
    isLoading: contentTypeLoading,
    error: contentTypeError
  } = useFetchData(`/contenttypes`);

  const header = shellHeaderBuilder({
    title: {
      title: t('trips')
    },
    cta: (
      <XGButton
        autoFocus
        id='button-add-trip'
        text={t('addTrip')}
        type='primary'
        size='large'
        variant='contained'
        onClick={() => setOpenModal(true)}
        startIcon={<PlusCircle size={20} />}
      />
    )
  });

  useEffect(() => {
    // Update page title
    document.title = 'Nivo - Trips';
  }, []);

  useEffect(() => {
    if (contentTypeData) {
      dispatch(updateContentTypes(contentTypeData));
    }
  }, [contentTypeData, contentTypeLoading, contentTypeError, dispatch]);

  // Sets up destinationsOptions in the format that
  // <CreateTrip /> needs it
  useEffect(() => {
    if (destinationsData && destinationsData.length !== 0) {
      const destinationOptions = [];
      destinationsData.map((destination) => {
        const { countryId, cityId, description } = destination;
        destinationOptions.push({
          countryId,
          cityId,
          title: description
        });
      });
      setDestinationOptions(destinationOptions);
    }
  }, [destinationsData]);

  // Sets up createdByOptions in the format that
  // <TripPanel /> needs it
  useEffect(() => {
    if (staffUsersData && staffUsersData.length !== 0) {
      const createdByOptions = [];
      staffUsersData.map((staffUser) => {
        const { userid, lastname, firstname } = staffUser;
        createdByOptions.push({
          userid,
          title: firstname + ' ' + lastname
        });
      });
      setCreatedByOptions(createdByOptions);
    }
  }, [staffUsersData]);

  return (
    <div id={id} data-testid='trip-page'>
      <ShellLayout id='shell-layout' headerData={header}>
        {!destinationsLoading &&
        !destinationsError &&
        destinationsData &&
        destinationsData.length !== 0 ? (
          <CreateTrip
            id='create-trip'
            openModal={openModal}
            setOpenModal={setOpenModal}
            destinations={destinationOptions}
          />
        ) : (
          <Box
            style={{
              paddingLeft: '16px',
              paddingRight: '16px',
              marginTop: '16px',
              marginBottom: '16px',
              width: '450px',
              height: '40px'
            }}
          >
            <Skeleton
              className='skeletonLoading'
              variant='rectangular'
              width={'100%'}
              height={'87%'}
            />
          </Box>
        )}

        {!tripStatusesLoading &&
        !tripStatusesError &&
        tripStatusesData &&
        tripStatusesData.length !== 0 ? (
          <TripsPanel
            destinations={destinationOptions}
            tripStatuses={(enableDisplayStatuses
              ? [
                  ...(tripStatusesData || []).filter(
                    (status) =>
                      !['TRAVELING', 'COMPLETE'].includes(
                        status?.tripstatuscode?.toUpperCase()
                      )
                  ),
                  {
                    tripstatusid: -1,
                    tripstatusname: t('statusTraveling'),
                    tripstatuscode: 'TRAVELING'
                  },
                  {
                    tripstatusid: -2,
                    tripstatusname: t('statusComplete'),
                    tripstatuscode: 'COMPLETE'
                  }
                ]
              : tripStatusesData || []
            ).sort((a, b) => {
              const orderMap = {};
              statuses.forEach((s, i) => {
                orderMap[s.tripstatuscode] = i;
              });
              const orderA = orderMap[a.tripstatuscode?.toUpperCase()] ?? 999;
              const orderB = orderMap[b.tripstatuscode?.toUpperCase()] ?? 999;
              return orderA - orderB;
            })}
            createdByOptions={createdByOptions}
          />
        ) : (
          <Box
            style={{
              paddingLeft: '16px',
              paddingRight: '16px',
              marginTop: '16px',
              marginBottom: '16px',
              width: '450px',
              height: '40px'
            }}
          >
            <Skeleton
              className='skeletonLoading'
              variant='rectangular'
              width={'100%'}
              height={'87%'}
            />
          </Box>
        )}
      </ShellLayout>
    </div>
  );
};

Trips.propTypes = {
  id: PropTypes.string.isRequired
};

export default Trips;
